import { Component, Input } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { PolicyHolder } from '../../models/policyHolder.model';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-policy-holder-details',
  imports: [MatCardModule, CommonModule],
  templateUrl: './policy-holder-details.component.html',
  styleUrl: './policy-holder-details.component.scss'
})
export class PolicyHolderDetailsComponent {
  @Input() policyHolder!: PolicyHolder;
}
